<template>
  <div class="ficha-foto galeria-aves">
    <img class="foto" :src="publicPath+cover" alt="" />
    <div class="degradado-aves"></div>
    <div class="cuadro-contraste-aves"></div>
    <p class="pie-foto">{{ name }} <i>{{ namec }}</i></p>
  </div>
</template>

<script>
export default {
  name: 'GaleriaAves',
  props: {
    name: String,
    namec: String,
    cover: String
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
}
</script>

<style scoped lang="scss">
.galeria-aves {
  width: calc(100% - #{$gap});
  overflow: hidden;
  margin: $gap*.5;
  .foto {
    object-fit: cover;
    height: 100%;
  }
  .pie-foto {
    bottom: $gap * -.5;
  }
  @media (min-width: map-get($media-queries-limit, "tablet")) {
    width: 204px;
    margin: 0;
  }
}
</style>
